import { type AddTabPanelInfo, TOTAL_DETAIL } from '@/common/stores/slide-detail';
import { DB_TYPE } from '@/common/define/common.define';
import type { SessionDetailParams } from './types';
import {
  getOracleSessionDetailAddition,
  getPostgresqlSessionDetailAddition,
  getMysqlSessionDetailAddition,
  getSqlServerSessionDetailAddition,
  getTiberoSessionDetailAddition,
  getAltibaseSessionDetailAddition,
  getRedshiftSessionDetailAddition,
} from './db';
import { InvalidDatabaseTypeError } from './error.utils';
import { getSessionDetailTimePeriodByInterval } from './time.utils';

type Params = Omit<SessionDetailParams, 'dbType'> & { dbType?: string };

export const useSessionDetail = () => {
  const ADDITION_GETTER_OBJ = {
    [DB_TYPE.SQLSERVER]: getSqlServerSessionDetailAddition,
    [DB_TYPE.ORACLE]: getOracleSessionDetailAddition,
    [DB_TYPE.POSTGRESQL]: getPostgresqlSessionDetailAddition,
    [DB_TYPE.MYSQL]: getMysqlSessionDetailAddition,
    [DB_TYPE.TIBERO]: getTiberoSessionDetailAddition,
    [DB_TYPE.ALTIBASE]: getAltibaseSessionDetailAddition,
    [DB_TYPE.REDSHIFT]: getRedshiftSessionDetailAddition,
  };

  const getSessionDetailAddition = (
    params: Params,
  ): Extract<AddTabPanelInfo, { type: typeof TOTAL_DETAIL.SESSION }> => {
    const { dbType = '', fromTime, toTime } = params;

    const additionGetterFn = ADDITION_GETTER_OBJ[dbType];
    if (!additionGetterFn) {
      throw new InvalidDatabaseTypeError({ dbType });
    }

    const sessionDetailTimeRange = getSessionDetailTimePeriodByInterval({ fromTime, toTime });
    const { name, addition } = additionGetterFn({ ...params, ...sessionDetailTimeRange });
    return {
      type: TOTAL_DETAIL.SESSION,
      name,
      session: addition,
    };
  };

  return { getSessionDetailAddition };
};
